/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type ModernWrapperQueryVariables = {};
export type ModernWrapperQueryResponse = {
    readonly viewer: {
        readonly " $fragmentRefs": FragmentRefs<"ModernWrapper_viewer">;
    };
};
export type ModernWrapperQuery = {
    readonly response: ModernWrapperQueryResponse;
    readonly variables: ModernWrapperQueryVariables;
};



/*
query ModernWrapperQuery {
  viewer {
    ...ModernWrapper_viewer
    id
  }
}

fragment ModernWrapper_viewer on Viewer {
  id
  user {
    id
    status
    emails
    givenName
    familyName
    createdTime
    members {
      value
      scope {
        type
        value
        id
      }
      id
    }
    webAppFlagsErrorable {
      __typename
      ... on GraphEntityError {
        statusCode
        message
      }
      ... on Flags {
        flags
      }
      ... on Node {
        __isNode: __typename
        id
      }
    }
    orgs(first: 1000000) {
      edges {
        node {
          id
          experiments
          createdTime
          name
        }
      }
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any, v1 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "createdTime",
        "storageKey": null
    } as any, v2 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "value",
        "storageKey": null
    } as any;
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "metadata": null,
            "name": "ModernWrapperQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "kind": "LinkedField",
                    "name": "viewer",
                    "plural": false,
                    "selections": [
                        {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "ModernWrapper_viewer"
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "ModernWrapperQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "kind": "LinkedField",
                    "name": "viewer",
                    "plural": false,
                    "selections": [
                        (v0 /*: any*/),
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                (v0 /*: any*/),
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "status",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "emails",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "givenName",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "familyName",
                                    "storageKey": null
                                },
                                (v1 /*: any*/),
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Urn",
                                    "kind": "LinkedField",
                                    "name": "members",
                                    "plural": true,
                                    "selections": [
                                        (v2 /*: any*/),
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Urn",
                                            "kind": "LinkedField",
                                            "name": "scope",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "type",
                                                    "storageKey": null
                                                },
                                                (v2 /*: any*/),
                                                (v0 /*: any*/)
                                            ],
                                            "storageKey": null
                                        },
                                        (v0 /*: any*/)
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "webAppFlagsErrorable",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "__typename",
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "statusCode",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "message",
                                                    "storageKey": null
                                                }
                                            ],
                                            "type": "GraphEntityError",
                                            "abstractKey": null
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "flags",
                                                    "storageKey": null
                                                }
                                            ],
                                            "type": "Flags",
                                            "abstractKey": null
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                (v0 /*: any*/)
                                            ],
                                            "type": "Node",
                                            "abstractKey": "__isNode"
                                        }
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "first",
                                            "value": 1000000
                                        }
                                    ],
                                    "concreteType": "OrgConnection",
                                    "kind": "LinkedField",
                                    "name": "orgs",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "OrgEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "Org",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        (v0 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "experiments",
                                                            "storageKey": null
                                                        },
                                                        (v1 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "name",
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": "orgs(first:1000000)"
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "e5f3a5e7199ad856faca9ae890619aac",
            "id": null,
            "metadata": {},
            "name": "ModernWrapperQuery",
            "operationKind": "query",
            "text": "query ModernWrapperQuery {\n  viewer {\n    ...ModernWrapper_viewer\n    id\n  }\n}\n\nfragment ModernWrapper_viewer on Viewer {\n  id\n  user {\n    id\n    status\n    emails\n    givenName\n    familyName\n    createdTime\n    members {\n      value\n      scope {\n        type\n        value\n        id\n      }\n      id\n    }\n    webAppFlagsErrorable {\n      __typename\n      ... on GraphEntityError {\n        statusCode\n        message\n      }\n      ... on Flags {\n        flags\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n    orgs(first: 1000000) {\n      edges {\n        node {\n          id\n          experiments\n          createdTime\n          name\n        }\n      }\n    }\n  }\n}\n"
        }
    } as any;
})();
(node as any).hash = '7fd83ff7949f9c555d7ef4e356a7b918';
export default node;
